import { render, staticRenderFns } from "./CommitmentHandlerSidebar.vue?vue&type=template&id=448b26ac&scoped=true&"
import script from "./CommitmentHandlerSidebar.vue?vue&type=script&lang=js&"
export * from "./CommitmentHandlerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CommitmentHandlerSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CommitmentHandlerSidebar.vue?vue&type=style&index=1&id=448b26ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448b26ac",
  null
  
)

export default component.exports